<template>
 <div data-v-d5c8035c="" data-v-2ac6a5fc="" class="container promotion">
		<div data-v-d5c8035c="" class="list">
			<div data-v-d5c8035c="" v-for="(item, index) in activitylistList" :key="index" @click="$parent.goNav(`/activeInfo?id=${item.id}`)">
				<div data-v-d5c8035c="" class="promo"><a data-v-d5c8035c="" href="javascript:void (0);" class="item.link">
					<div data-v-d5c8035c="" class="promo-img"><img data-v-d5c8035c="" class="img-responsive" :src="item.banner"

           lazy="loaded">
						<div data-v-d5c8035c="" class="promo-label">新活动</div>
					</div>
					<div data-v-d5c8035c="" class="info">
						<div data-v-d5c8035c="" class="title">
							<h3 data-v-d5c8035c="">{{ item.title }}</h3>
						</div>
						<!-- <p data-v-d5c8035c="">赢千万豪奖 主播同欢YYDS</p> -->
						<p data-v-d5c8035c=""></p>
						<span data-v-d5c8035c="" class="date">{{item.created_at}}</span></div>
					</a></div>
			</div>
	


			
		</div>
	</div>
</template>
<script>
export default {
  name: 'activeList',
  data() {
    return { activitylistList:[] };
  },
  created() {
    let that = this;
    that.activitylist();

  },
  methods: {
       activitylist() {
      let that = this;
      let info =  { type:'' };
      that.$parent.showLoading();
      that.$apiFun.post('/api/activitylist', info).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.activitylistList = res.data.data;
        }
        that.$parent.hideLoading();
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/chunk-38eb6c31.8e3fbc77.css';
.promotion .promo .promo-img[data-v-d5c8035c][data-v-076663fa] {
 height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/main/activeList.vue